import isEmpty from 'lodash/isEmpty';
import {mapAxleTimezoneToIANA} from './Timezone';

const SessionDateUtil = {
    getCoachName(coachingSession, appointmentData, enableAxleForm) {
        if (!isEmpty(coachingSession)) {
            return enableAxleForm
                ? coachingSession?.provider_full_name
                : coachingSession?.staff?.fullName;
        } else if (!isEmpty(appointmentData)) {
            return appointmentData?.coach;
        } else {
            return '';
        }
    },
    getScheduledDate(
        coachingSession,
        appointmentData,
        type,
        intlFormat,
        enableAxleForm
    ) {
        const helper = unixTime => {
            if (type === 1) {
                const time = `${intlFormat(unixTime, {
                    month: 'long',
                    day: 'numeric',
                })} at ${intlFormat(unixTime, {
                    hour: 'numeric',
                    minute: 'numeric',
                })}`;

                return time;
            } else if (type === 2) {
                const time = intlFormat(unixTime, {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                });

                return time;
            } else if (type === 3) {
                const time = `${intlFormat(unixTime, {
                    weekday: 'long',
                    month: 'long',
                    day: 'numeric',
                })} at ${intlFormat(unixTime, {
                    hour: 'numeric',
                    minute: 'numeric',
                })}`;

                return time;
            }
        };

        if (!isEmpty(coachingSession)) {
            const unixTime = new Date(
                enableAxleForm
                    ? coachingSession?.start_date_time
                    : coachingSession?.clientStartDateTimeUTC
            );

            return helper(unixTime);
        } else if (!isEmpty(appointmentData)) {
            const unixTime = enableAxleForm
                ? appointmentData?.startDate
                : new Date(appointmentData?.startDate);

            return helper(unixTime);
        } else {
            return '';
        }
    },
    getScheduledTime(
        coachingSession,
        appointmentData,
        intlFormat,
        enableAxleForm
    ) {
        let timezone;

        const helper = unixTime => {
            const time = `${intlFormat(unixTime, {
                hour: 'numeric',
                minute: 'numeric',
                timeZoneName: 'short',
                ...(enableAxleForm && {
                    timeZone: mapAxleTimezoneToIANA(timezone),
                }),
            })}`;

            return time;
        };

        if (!isEmpty(coachingSession)) {
            if (enableAxleForm) {
                timezone = coachingSession?.member_timezone;
            }

            const unixTime = new Date(
                enableAxleForm
                    ? coachingSession?.start_date_time
                    : coachingSession?.clientStartDateTimeUTC
            );

            return helper(unixTime);
        } else if (!isEmpty(appointmentData)) {
            if (enableAxleForm) {
                timezone = appointmentData?.timezone;
            }
            const unixTime = new Date(appointmentData?.startDate);

            return helper(unixTime);
        } else {
            return '';
        }
    },
    getCallTypeV2(text) {
        const ary = text?.split(':') ?? '';
        const poppedValue = ary?.length ? ary?.pop() : '';
        const formattedValue = poppedValue
            ?.toString()
            .replace('(Spanish)', '')
            .trim();

        return formattedValue?.replace(' ', '')?.toLocaleLowerCase();
    },
};

export default SessionDateUtil;
